export const WINDOW_RESIZE = 'windowResize';
export const SIDE_BAR_LOCK_CHANGE = 'sidebarLockChange';
export const EXPAND_CHANGE = 'expandChange';
export const ROOT_DIALOG_RESIZE_EVENT_NAME = 'root-dialog-resize';
export default {WINDOW_RESIZE, SIDE_BAR_LOCK_CHANGE, EXPAND_CHANGE, ROOT_DIALOG_RESIZE_EVENT_NAME};
